export const UcErrorMessage = {
    MAX_ATTEMPT_EXCEEDED: `Error 1001: Unable to find service template from server in requested language. Please contact support`,
    OPTIN_CONSENT_MISSING: `Error 1002: No Optin service found. Please contact support`
};